import { makeStyles } from 'tss-react/mui';

const name = 'NetworkUsage';

export const useNetworkUsageStyles = makeStyles<boolean>({ name })(
  (theme, hasCached) => ({
    content: {
      display: 'flex',
      gap: theme.spacing(7),

      [theme.breakpoints.down('sm')]: {
        display: 'grid',
        gridTemplateAreas: hasCached
          ? `
            "total   total"
            "average cached"
          `
          : `
            "total   total"
            "average average"
          `,
        gap: theme.spacing(2),
      },
    },
    totalCard: {
      gridArea: 'total',

      flex: 1,
    },
    averageCard: {
      gridArea: 'average',

      flex: 1,
    },
    cachedCard: {
      gridArea: 'cached',

      flex: 1,
    },
  }),
);
